/**
 * Fix properties of WapiContract after editing
 * @param {} wapiContract 
 */
export function fixProps(wapiContract) {
  if (wapiContract.reanalysis_settings.available_from === '') {
    wapiContract.reanalysis_settings.available_from = null;
  }

  if (wapiContract.reanalysis_settings.available_to === '') {
    wapiContract.reanalysis_settings.available_to = null;
  }

  if (!wapiContract.reanalysis_settings.parameters.length) {
    wapiContract.reanalysis_settings = null;
  }
}